export const getWidgetWidth = ({ layoutItemWidth, screenWidth, widgetRefWidth, windowSize, scale, }) => {
    if (layoutItemWidth.endsWith("px")) {
        return parseInt(layoutItemWidth) / scale;
    }
    if (layoutItemWidth.endsWith("%")) {
        if (!widgetRefWidth && !windowSize) {
            return (parseInt(layoutItemWidth) * screenWidth) / 100 / scale;
        }
        return widgetRefWidth
            ? widgetRefWidth / scale
            : ((parseInt(layoutItemWidth) / 100) * windowSize) / scale;
    }
    return parseInt(layoutItemWidth) / scale;
};
export const valueFromString = (value, size, valueIfNaN = 0) => {
    // @ts-ignore
    if (value === "auto")
        return "auto";
    if (value === "")
        return 0;
    if (typeof value === "number")
        return value;
    if (value.endsWith("%")) {
        const result = (parseFloat(value.substring(0, value.length - 1)) * size) / 100;
        return isNaN(result) ? valueIfNaN : result;
    }
    else if (value.endsWith("px")) {
        const result = parseFloat(value.substring(0, value.length - 2));
        return isNaN(result) ? valueIfNaN : result;
    }
    const result = parseFloat(value);
    return isNaN(result) ? valueIfNaN : result;
};
export const pxToPercents = (value, size) => {
    if (value === "auto")
        return "auto";
    let formattedValue = parseInt(value);
    if (value.endsWith("px")) {
        formattedValue = parseFloat(value.substring(0, value.length - 2));
    }
    return `${Math.round((formattedValue / size) * 100).toString()}%`;
};
export const percentsToPx = (value, size) => {
    if (value === "auto")
        return "auto";
    return `${Math.round((parseFloat(value.substring(0, value.length - 1)) * size) / 100)}px`;
};
export const getWidgetResize = ({ isSelected, isLocked, resize, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return {
        bottom: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_a = resize === null || resize === void 0 ? void 0 : resize.bottom) !== null && _a !== void 0 ? _a : true
            : false,
        bottomLeft: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_b = resize === null || resize === void 0 ? void 0 : resize.bottomLeft) !== null && _b !== void 0 ? _b : true
            : false,
        bottomRight: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_c = resize === null || resize === void 0 ? void 0 : resize.bottomRight) !== null && _c !== void 0 ? _c : true
            : false,
        left: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_d = resize === null || resize === void 0 ? void 0 : resize.left) !== null && _d !== void 0 ? _d : true
            : false,
        right: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_e = resize === null || resize === void 0 ? void 0 : resize.right) !== null && _e !== void 0 ? _e : true
            : false,
        top: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_f = resize === null || resize === void 0 ? void 0 : resize.top) !== null && _f !== void 0 ? _f : true
            : false,
        topLeft: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_g = resize === null || resize === void 0 ? void 0 : resize.topLeft) !== null && _g !== void 0 ? _g : true
            : false,
        topRight: isSelected && !isLocked
            ? resize === true || resize === false
                ? true
                : (_h = resize === null || resize === void 0 ? void 0 : resize.topRight) !== null && _h !== void 0 ? _h : true
            : false,
    };
};
